import PublisherPayoutsActions from '../../../../actions/PublisherPayoutsActions';
import query from '../../../../helpers/query';

let lastParams = null;

export const actions = {
    getPayouts(state) {
        const cleanedState = { ...state };
        
        if (cleanedState.statuses) {
            if (Array.isArray(cleanedState.statuses) && cleanedState.statuses.length === 1 && 
                cleanedState.statuses[0].value && cleanedState.statuses[0].value.toLowerCase() === 'all') {
                delete cleanedState.statuses;
            } else if (typeof cleanedState.statuses === 'string' && cleanedState.statuses.toLowerCase() === 'all') {
                delete cleanedState.statuses;
            } else if (Array.isArray(cleanedState.statuses) && cleanedState.statuses.length === 0) {
                delete cleanedState.statuses;
            }
        }
        
        if (cleanedState.sources) {
            if (Array.isArray(cleanedState.sources) && cleanedState.sources.length === 1 && 
                cleanedState.sources[0].value && cleanedState.sources[0].value.toLowerCase() === 'conversion') {
                delete cleanedState.sources;
            } else if (typeof cleanedState.sources === 'string' && cleanedState.sources.toLowerCase() === 'conversion') {
                delete cleanedState.sources;
            } else if (Array.isArray(cleanedState.sources) && cleanedState.sources.length === 0) {
                delete cleanedState.sources;
            }
        }
        
        const params = query.parseToSend(cleanedState);
        const paramsStr = JSON.stringify(params);
        
        if (lastParams === paramsStr) {
            return;
        }
        
        lastParams = paramsStr;
        PublisherPayoutsActions.getPayouts(params);
    }
};
